<mat-accordion [multi]="true">
    <mat-expansion-panel [expanded]="true" class="thick border">
        <mat-expansion-panel-header>
            <mat-panel-title fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <mat-icon>security</mat-icon>
                <span class="main-title">Ověření identity</span>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
            <div class="pb-2">
                <span class="font-semibold">Bank iD</span>
                je metoda digitálního ověření totožnosti, vaše digitální občanka. Díky ní se přihlásíte do aplikací
                a&nbsp;klientských zón, sjednáte služby a podepíšete dokumenty online. Je to stejně jednoduché jako se
                přihlásit do internetového bankovnictví.
            </div>
            <div class="pb-2">
                V hyponamíru vám ověření přes Bank ID usnadní cestu k hypotéce. Díky této službě totiž
                <span class="font-semibold">nemusíte ručně zadávat své osobní údaje</span>. Formulář vám automaticky
                předvyplníme. Jak chráníme vaše osobní údaje se dočtete v&nbsp;našich
                <a href="https://www.hyponamiru.cz/zasady-ochrany-osobnich-udaju/" target="_blank">
                    Zásadách ochrany osobních údajů </a
                >.
            </div>
            <div class="pb-4">
                Ověřením přes Bank ID nám
                <span class="font-semibold">pomůžete splnit nezbytné kroky,</span>
                které musíme jako zprostředkovatel hypotečních úvěrů ctít. Zkratky AML a&nbsp;KYC jste možná už
                zaslechli. Ve zkratce to znamená, že je bankovní instituce povinna si ověřit, s&nbsp;kým jedná
                a&nbsp;z&nbsp;jakého zdroje budete splácet hypotéku. Více se dočtete například
                <a
                    href="https://www.cnb.cz/cs/o_cnb/cnblog/Identifikace-a-kontrola-klientu-financnich-instituci-jako-nastroj-v-boji-proti-prani-spinavych-penez/"
                    target="_blank">
                    na webu ČNB </a
                >.
            </div>
        </div>
        <div>
            @for (applicant of mortgage._contacts; track applicant; let index = $index) {
                <div class="ui-panel">
                    <div class="ui-panel-header" fxLayout="row" fxLayoutAlign="space-between center">
                        <h2>{{ applicant._id | applicantName: mortgage._contacts }}</h2>
                    </div>
                    <div
                        class="ui-panel-content"
                        fxLayout="row"
                        fxLayoutAlign="space-between center"
                        fxLayoutGap="20px">
                        <div fxFlex="100" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            @if (applicant.verifiedStatus?.bankId) {
                                <div [ngClass]="applicant.verifiedStatus?.bankId | bankIdStatus" class="state">
                                    <mat-icon>
                                        {{ applicant.verifiedStatus?.bankId | bankIdIndicator }}
                                    </mat-icon>
                                    {{ applicant.verifiedStatus?.bankId | option: BankIdStatusList }} (Bankovní
                                    identita)
                                </div>
                            }
                            @if (applicant.verifiedStatus?.courier) {
                                <div [ngClass]="applicant.verifiedStatus?.courier | bankIdStatus" class="state">
                                    <mat-icon>
                                        {{ applicant.verifiedStatus?.courier | bankIdIndicator }}
                                    </mat-icon>
                                    {{ applicant.verifiedStatus?.courier | option: BankIdStatusList }} (Kurýr)
                                </div>
                            }
                            @if (applicant.verifiedStatus?.internal) {
                                <div [ngClass]="applicant.verifiedStatus?.internal | bankIdStatus" class="state">
                                    <mat-icon>
                                        {{ applicant.verifiedStatus?.internal | bankIdIndicator }}
                                    </mat-icon>
                                    {{ applicant.verifiedStatus?.internal | option: BankIdStatusList }} (Interně)
                                </div>
                            }
                        </div>
                        <a
                            class="btn btn-sm primary-transparent bankid-page-confirm-identity-dialog-open"
                            style="height: 47px; padding: 13px 15px"
                            fxFlex="175px"
                            href="https://www.hyponamiru.cz/bankovni-identita-vam-usetri-cas-i-penize/"
                            mat-button
                            target="_blank"
                            type="button"
                            >Více informací
                        </a>
                        @if (
                            applicant.verifiedStatus?.bankId !== BankIdStatusEnum.verified &&
                            applicant.verifiedStatus?.courier !== BankIdStatusEnum.verified &&
                            applicant.verifiedStatus?.internal !== BankIdStatusEnum.verified
                        ) {
                            <app-bank-id-button (click)="bankIdDialog(applicant)"> </app-bank-id-button>
                        }
                    </div>
                </div>
            }

            <div class="font-semibold pb-1">Kroky k ověření totožnosti přes Bank iD</div>
            <ul class="list-disc pl-4 pb-4">
                <li>Vyberete svou banku.</li>
                <li>Na stránce své banky se přihlásíte stejně jako do svého bankovnictví.</li>
                <li>Přihlášení potvrdíte v mobilní aplikaci banky či zadáním zaslané SMS.</li>
                <li>Odsouhlasíte, že banka předá vybrané osobní údaje poskytovateli služby.</li>
                <li>Vaše totožnost je ověřena.</li>
            </ul>

            <div class="font-semibold pb-1">Zabezpečení vašich osobních údajů</div>
            <ul class="list-disc pl-4">
                <li>
                    Ověření Vaší totožnosti probíhá přes Vaši banku a v prostředí Vaší banky. Pro banky je ochrana
                    bezpečí klientů maximální prioritou a odpovídají za bezpečnost ověření.
                </li>
                <li>
                    Bankovní identita, a.s. ani poskytovatelé služeb, pro které ověřujete svoji totožnost, nikdy nevidí
                    Vaše přihlašovací údaje, ani informace o Vašich financích.
                </li>
                <li>
                    Využitím Bank iD nedochází k propojení s Vaším bankovním účtem, pouze využíváte stejné přihlašovací
                    údaje jako do svého internetového bankovnictví.
                </li>
                <li>
                    Při ověření totožnosti přes Bank iD sami rozhodujete o tom, jaké osobní údaje předáváte
                    poskytovatelům služeb a toto předání dat výslovně potvrzujete při každém využití Bank iD.
                </li>
            </ul>
        </div>
    </mat-expansion-panel>
</mat-accordion>
